import { create } from 'zustand';
import { persist } from 'zustand/middleware';
// Location is persisted to localStorage — not sensitive, improves UX on return visits
export const useLocationStore = create()(persist((set) => ({
    coordinates: null,
    city: null,
    state: null,
    displayAddress: null,
    source: null,
    lastRefreshedAt: null,
    setLocation: (coordinates, city, displayAddress, source, state) => set({
        coordinates,
        city,
        displayAddress,
        source,
        state: state ?? null,
        lastRefreshedAt: source === 'gps' ? Date.now() : null,
    }),
    clearLocation: () => set({
        coordinates: null,
        city: null,
        state: null,
        displayAddress: null,
        source: null,
        lastRefreshedAt: null,
    }),
}), { name: 'grandxl-location' }));
//# sourceMappingURL=location.store.js.map